import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import { deleteQuestion, getQuestions, getUserAttempts, reorderQuestion } from "../../../services/QuestionService";
import { MoveDown, MoveUp } from "lucide-react";

const UserQuizAttempt = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const hasFetched = useRef(false);
    const [userAttempts, setUserAttempts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const location = useLocation();

    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const [data, setData] = useState([]);
    const sort = 10;
    const activePag = useRef(0);
    const [test, settest] = useState(0);

    const chageData = (frist, sec) => {
        for (var i = 0; i < data.length; ++i) {
            if (i >= frist && i < sec) {
                data[i].classList.remove("d-none");
            } else {
                data[i].classList.add("d-none");
            }
        }
    };

    const fetchQuestions = async (pageNumber = 1, query = "") => {
        try {
            setLoading(true);
            const response = await getUserAttempts(pageNumber, limit, query);
            const { data, pagination } = response.data;
            setUserAttempts(data || []);
            setTotalPages(pagination?.totalPages || 0);
            setTotalItems(pagination?.total || 0);
            setPage(pagination?.page || 1);
        } catch (error) {
            console.error("Error fetching countries:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetched.current) {
            const stateData = location.state;

            if (stateData) {
                setSearchTerm(stateData.searchTerm || "");
                fetchQuestions(stateData.page || 1, stateData.searchTerm || "");
            } else {
                fetchQuestions(1);
                hasFetched.current = true;
            }
        }
    }, []);

    // --- When data changes, update DOM rows (for pagination)
    useEffect(() => {
        setData(document.querySelectorAll("#country_wrapper tbody tr"));
    }, [userAttempts, test]);

    activePag.current === 0 && chageData(0, sort);

    const handleSearch = () => {
        setPage(1);
        fetchQuestions(1, searchTerm);
    };

    const handleReset = () => {
        setSearchTerm("");
        setPage(1);
        fetchQuestions(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
            fetchQuestions(newPage, searchTerm);
        }
    };

    const handleDeleteUserAttempts = (questionId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete User Attempts Data?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dd6b55",
            cancelButtonColor: "#aaa",
            confirmButtonText: "Yes, delete it!!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Call your delete API here
                    await deleteQuestion(questionId); // make sure you have a deleteCountry function
                    Swal.fire("Suceess!", "User Attempts Deleted successfully!", "success");
                    // Refresh the list
                    fetchQuestions(page, searchTerm);
                } catch (error) {
                    Swal.fire("Error!", "Failed to delete user attempt.", "error");
                }
            }
        });
    };

    return (
        <>
            <PageTitle
                activeMenu="User Attempts"
                motherMenu="User Attempts"
                activeMenuLink={"user-attempts"}
                motherMenuLink={"user-attempts"}
            />
            <div className="row">
                <div className="col-xl-12">
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`} onClick={() => setOpen(!open)}>
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-sm-6">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control mb-3 mb-xl-0"
                                                id="exampleFormControlInput1"
                                                placeholder="Search by name..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-xl-3 col-sm-6 align-self-end">
                                            <button
                                                className="btn btn-primary me-2 rounded-sm"
                                                title="Click here to Search"
                                                type="button"
                                                onClick={handleSearch}
                                            >
                                                <i className="fa fa-search me-1"></i>Filter
                                            </button>
                                            <button
                                                className="btn btn-danger light rounded-sm"
                                                title="Click here to remove filter"
                                                type="button"
                                                onClick={handleReset}
                                            >
                                                <i className="fa fa-undo me-1"></i>
                                                Remove Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`} onClick={() => setOpen2(!open2)}>
                            <div className="cpa">
                                <i className="fa-solid fa-user-pen me-1" />
                                Questions List
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body py-3">
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : (
                                        <div className="table-responsive order-list-table">
                                            <div
                                                id="country_wrapper"
                                                className="dataTables_wrapper no-footer"
                                            >
                                                <table className="table table-responsive-lg table-condensed flip-content">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-black">S.No</th>
                                                            <th className="text-black">User Name</th>
                                                            <th className="text-black">User Mobile Number</th>
                                                            <th className="text-black">Total Questions</th>
                                                            <th className="text-black">Correct Answers</th>
                                                            <th className="text-black">Score Percentage</th>
                                                            <th className="text-black">Submitted At</th>
                                                            <th className="text-black text-end">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userAttempts.length > 0 ? (
                                                            userAttempts.map((item, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{(page - 1) * limit + ind + 1}</td>
                                                                    <td className="truncate">{item.user_name}</td>
                                                                    <td className="truncate">{item.user_mobile}</td>
                                                                    <td className="truncate">{item.total_questions}</td>
                                                                    <td className="truncate">{item.correct_answers}</td>
                                                                    <td className="truncate">{item.score_percentage}</td>
                                                                    <td>
                                                                        {new Date(
                                                                            item.createdAt
                                                                        ).toLocaleDateString("en-GB", {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        })}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <Link
                                                                            to={`/view-user-attempt/${item.id}`}
                                                                            state={{ page, searchTerm }}
                                                                            className="btn btn-primary btn-sm content-icon me-1"
                                                                        >
                                                                            <i className="fa fa-eye"></i>
                                                                        </Link>
                                                                        <Link
                                                                            to={"#"}
                                                                            className="btn btn-danger btn-sm content-icon ms-1"
                                                                            onClick={() =>
                                                                                handleDeleteUserAttempts(item.id)
                                                                            }
                                                                        >
                                                                            <i
                                                                                className="fa-solid fa-trash"
                                                                            />
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    No quizzes found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {totalPages > 0 && (
                                                    <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                        <div className="dataTables_info">
                                                            {totalItems > 0 && (
                                                                <>
                                                                    Showing {(page - 1) * limit + 1} to{" "}
                                                                    {Math.min(page * limit, totalItems)} of{" "}
                                                                    {totalItems} entries
                                                                </>
                                                            )}
                                                        </div>

                                                        <div
                                                            className="dataTables_paginate paging_simple_numbers"
                                                            id="example2_paginate"
                                                        >
                                                            {/* Prev button */}
                                                            <Link
                                                                className={`paginate_button previous ${page === 1 ? "disabled" : ""
                                                                    }`}
                                                                to="#"
                                                                onClick={() =>
                                                                    page > 1 && handlePageChange(page - 1)
                                                                }
                                                            >
                                                                <i className="fa fa-angle-double-left" />
                                                            </Link>

                                                            <span>
                                                                {Array.from(
                                                                    { length: totalPages },
                                                                    (_, i) => i + 1
                                                                )
                                                                    .filter((i) => {
                                                                        // Always show first 2 and last 2
                                                                        if (i <= 2 || i > totalPages - 2)
                                                                            return true;
                                                                        // Show nearby pages of the current one
                                                                        if (Math.abs(page - i) <= 1) return true;
                                                                        return false;
                                                                    })
                                                                    .reduce((acc, i, index, arr) => {
                                                                        // Add ellipsis between distant page numbers
                                                                        if (index > 0 && i - arr[index - 1] > 1)
                                                                            acc.push("ellipsis");
                                                                        acc.push(i);
                                                                        return acc;
                                                                    }, [])
                                                                    .map((item, index) =>
                                                                        item === "ellipsis" ? (
                                                                            <span
                                                                                key={index}
                                                                                className="paginate_button disabled"
                                                                            >
                                                                                ...
                                                                            </span>
                                                                        ) : (
                                                                            <Link
                                                                                key={index}
                                                                                to="#"
                                                                                className={`paginate_button ${page === item ? "current" : ""
                                                                                    }`}
                                                                                onClick={(e) => {
    e.preventDefault();
    handlePageChange(item);
  }}
                                                                            >
                                                                                {item}
                                                                            </Link>
                                                                        )
                                                                    )}
                                                            </span>

                                                            {/* Next button */}
                                                            <Link
                                                                className={`paginate_button next ${page === totalPages ? "disabled" : ""
                                                                    }`}
                                                                to="#"
                                                                onClick={() =>
                                                                    page < totalPages &&
                                                                    handlePageChange(page + 1)
                                                                }
                                                            >
                                                                <i className="fa fa-angle-double-right" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </div >
            </div >
        </>
    );
};
export default UserQuizAttempt;
